import React, { Component } from "react";
import classnames from "classnames";

import { HStack } from "@formant/ui/component/common/HStack";
import { Icon, IconName } from "@formant/ui/component/common/Icon";

import { Button, IButtonProps } from "./Button";
import * as styles from "./InputButton.scss";

export interface IInputButtonProps {
    text: string;
    mainIcon?: IconName;
    actionIcon?: IconName;
    className?: string;
}

export class InputButton extends Component<IInputButtonProps & IButtonProps> {
    public render() {
        const { text, mainIcon, actionIcon, className, ...props } = this.props;
        return (
            <Button
                className={classnames(styles["input-button"], className)}
                {...props}
            >
                <HStack
                    innerSpacing="sm"
                    vAlign="center"
                    className={styles.main}
                >
                    {mainIcon && (
                        <Icon className={styles.icon} name={mainIcon} />
                    )}
                    <div className={styles.text}>{text}</div>
                </HStack>
                <HStack
                    hAlign="center"
                    vAlign="center"
                    className={styles.actions}
                >
                    {actionIcon && (
                        <Icon className={styles.icon} name={actionIcon} />
                    )}
                </HStack>
            </Button>
        );
    }
}
